var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-center",
        class: { "default-page-paddings": _vm.withTitle },
      },
      [
        _c("div", { staticClass: "container container-medium article" }, [
          _vm.withTitle
            ? _c("h1", { staticClass: "heading black" }, [
                _vm._v(_vm._s(_vm.$t("header_how_does_it_work"))),
              ])
            : _vm._e(),
          _vm.locale == "ro"
            ? _c("div", [
                _vm.showBoth == "both" || _vm.showBoth == "vignette"
                  ? _c("div", [
                      _vm._m(0),
                      _c("div", { staticClass: "reading" }, [
                        _c(
                          "p",
                          [
                            _vm._v("Comandă online rovinieta pe "),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "vignette" } } },
                              [_vm._v("E-rovinieta")]
                            ),
                          ],
                          1
                        ),
                        _c("p", [
                          _c(
                            "strong",
                            [
                              _vm._v(
                                "Cum poți achiziționa rovinieta online de pe "
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "vignette" } } },
                                [_vm._v("E-rovinieta")]
                              ),
                              _vm._v(":"),
                            ],
                            1
                          ),
                        ]),
                        _vm._m(1),
                        _c("p", [
                          _vm._v(
                            " După confirmarea plății se emit rovinietele și primești prin e-mail factura și datele rovinietelor și prin SMS datele rovinietelor emise. "
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Comenzile, rovinietele emise si facturile se vor putea accesa oricând în contul personal de pe site"
                          ),
                        ]),
                        _c(
                          "p",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "custom-link",
                                attrs: { to: { name: "questions" } },
                              },
                              [_vm._v("Apasati aici")]
                            ),
                            _vm._v(
                              " pentru a afla cum se pot corecta rovinietele deja emise."
                            ),
                          ],
                          1
                        ),
                        _vm._m(2),
                        _c("p", [
                          _vm._v(
                            "NU se pot emite roviniete cu data de valabilitate anterioară datei de emitere."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "NU se pot emite roviniete decât cu cel mult 30 zile anterior datei de început a valabilității."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            " Rovinietele se emit numai dupa confirmarea plății sumei în contul bancar al UNTRR (în câteva minute în cazul plății online cu cardul bancar finalizate sau în aceeași zi sau în ziua următoare în cazul plății prin ordin de plată). "
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            " DUPA TRIMITEREA UNEI COMENZI NU CIRCULATI PE DRUMURILE NAȚIONALE/AUTOSTRĂZI ÎNAINTE DE A PRIMI CONFIRMAREA EMITERII ROVINIETEI, PRIN SMS ȘI/SAU PE E-MAIL! "
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.showBoth == "both" || _vm.showBoth == "toll"
                  ? _c("div", [
                      _vm._m(3),
                      _c("div", { staticClass: "reading" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "Comandă online trecerile de pod (peaj) pentru Fetești-Cernavodă pe "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "toll" } } },
                              [_vm._v("Taxa-pod-fetesti")]
                            ),
                          ],
                          1
                        ),
                        _c("p", [
                          _c(
                            "strong",
                            [
                              _vm._v(
                                "Cum poți achiziționa trecerile de pod (peaj) online de pe "
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "toll" } } },
                                [_vm._v("Taxa-pod-fetesti")]
                              ),
                              _vm._v(":"),
                            ],
                            1
                          ),
                        ]),
                        _vm._m(4),
                        _vm._m(5),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _c("div", [
                _vm.showBoth == "both" || _vm.showBoth == "vignette"
                  ? _c("div", [
                      _vm._m(6),
                      _c("div", { staticClass: "reading" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "Order Romanian vignette (rovinieta) online on "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "vignette" } } },
                              [_vm._v("E-rovinieta")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "p",
                          [
                            _vm._v(
                              "How can you buy Romanian vignette (rovinieta) online from "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "vignette" } } },
                              [_vm._v("E-rovinieta")]
                            ),
                            _vm._v(":"),
                          ],
                          1
                        ),
                        _vm._m(7),
                        _vm._m(8),
                        _c("p", [
                          _vm._v(
                            "You cannot issue a vignette (rovinieta) with a validity date prior to the date of issue."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Vignettes (roviniete) may NOT be issued until 30 days before the start date of validity."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Vignettes (roviniete) are issued only after confirmation of payment of the amount in the bank account of UNTRR (in a few minutes in case of online payment or on the same day or the next day in case of payment by bank order)."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "AFTER SENDING AN ORDER, DO NOT TRAVEL ON NATIONAL ROADS / HIGHWAYS BEFORE RECEIVING THE CONFIRMATION OF THE ISSUE OF THE VIGNETTE (ROVINIETA), BY SMS AND / OR BY E-MAIL!"
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.showBoth == "both" || _vm.showBoth == "toll"
                  ? _c("div", [
                      _vm._m(9),
                      _c("div", { staticClass: "reading" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "Order online bridge tolling for Fetești-Cernavoda on "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "toll" } } },
                              [_vm._v("Taxa-pod-fetesti")]
                            ),
                          ],
                          1
                        ),
                        _c("p", [
                          _c(
                            "strong",
                            [
                              _vm._v("How to buy bridge tolling online from "),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "toll" } } },
                                [_vm._v("Taxa-pod-fetesti")]
                              ),
                              _vm._v(":"),
                            ],
                            1
                          ),
                        ]),
                        _vm._m(10),
                        _c("p", [
                          _vm._v(
                            "After confirming the payment, the bridge tolls are issued and you will receive by e-mail the invoice and the toll data and by SMS the toll data issued."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Orders, tolls issued and invoices can be accessed at any time in the personal account on the website."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Attention! Once purchased, a bridge toll is valid for 1 year. Tolls can be paid before using the bridges or until 24:00 the day after crossing."
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "special-title" }, [
      _c("strong", [_vm._v("Rovinieta")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          " Selectează categoria vehiculului (de ex. Autoturisme, Transport Marfa MTMA <= 3,5t, Transport Marfa 3,5t < MTMA <= 7,5t etc. Categoria autovehiculului o poți găsi la poziția J, iar masa tehnică maximă autorizată (MTMA) la poziția F1 din talonul/certificatul de inmatriculare) "
        ),
      ]),
      _c("li", [
        _vm._v(
          " Selectează perioada de valabilitate a rovinietei, data de la care intră în vigoare rovinieta, numărul de înmatriculare, seria de șasiu (deși nu este obligatorie la rovinietele de 1 zi și 7 zile, recomandăm trecerea seriei de sasiu pentru corectitudinea datelor), țara de înmatriculare și, opțional, motivul categoriei inferioare (se completează doar în cazul în care categoria selectată este inferioară celei din evidențele RAR). "
        ),
      ]),
      _c("li", [
        _vm._v(
          " Adaugă în coș rovinieta. Poți adăuga în coș și alte roviniete, prin apăsarea butonului ”mai cumpără” "
        ),
      ]),
      _c("li", [
        _vm._v(
          " La pasul următor poți intra în contul tău și să alegi datele de facturare deja salvate sau poți plasa comanda fără cont completând datele solicitate în formular. Dacă ești persoană juridică trebuie să ne lași doar adresa de email și numărul de telefon, iar la CUI să treci codul unic de înregistrare/codul de identificare fiscal și să apeși pe butonul VERIFICA, iar datele firmei tale vor fi precompletate automat "
        ),
      ]),
      _c("li", [
        _vm._v(
          " La pasul următor poți alege modalitatea de plată – online cu card bancar prin intermediul procesatorului securizat de carduri sau prin bancă cu ordin de plată. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("ATENȚIE!")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "special-title" }, [
      _c("strong", [_vm._v("Taxa pod Fetesti")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          " Selectează categoria vehiculului (de ex. Categoria 1 - Autoturisme, Transport Marfa MTMA <= 3,5t, Categoria 2 - Transport Marfa 3,5t < MTMA <= 7,5t/microbuze etc. Categoria autovehiculului o poți găsi la poziția J, iar masa tehnică maximă autorizată (MTMA) la poziția F1 din talonul/certificatul de inmatriculare) "
        ),
      ]),
      _c("li", [
        _vm._v(
          " Selectează numărul de treceri (1, 2 sau 20 de treceri), numărul de înmatriculare, seria de șasiu, țara de înmatriculare și, opțional, motivul categoriei inferioare (se completează doar în cazul în care categoria selectată este inferioară celei din evidențele RAR). "
        ),
      ]),
      _c("li", [
        _vm._v(
          " Adaugă în coș peajul. Poți adăuga în coș și alte peaje, prin apăsarea butonului ”mai cumpără” "
        ),
      ]),
      _c("li", [
        _vm._v(
          " La pasul următor poți intra în contul tău și să alegi datele de facturare deja salvate sau poți plasa comanda fără cont completând datele solicitate în formular. Dacă ești persoană juridică trebuie să ne lași doar adresa de email și numărul de telefon, iar la CUI să treci codul unic de înregistrare/codul de identificare fiscal și să apeși pe butonul VERIFICA, iar datele firmei tale vor fi precompletate automat "
        ),
      ]),
      _c("li", [
        _vm._v(
          " La pasul următor poți alege modalitatea de plată – online cu card bancar prin intermediul procesatorului securizat de carduri sau prin bancă cu ordin de plată. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        " După confirmarea plății se emit trecerile de pod (peajele) și primești prin e-mail factura și datele rovinietelor și prin SMS datele peajelor emise."
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " Comenzile, peajele emise si facturile se vor putea accesa oricând în contul personal de pe site."
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " De reținut! Odată achiziționată, o trecere de pod (peaj) este valabilă 1 an de zile. Peajele se poat achita înainte de utilizarea podurilor sau până la ora 24:00 a zilei următoare trecerii. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "special-title" }, [
      _c("strong", [_vm._v("Vignette")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          " - Select the vehicle category (e.g. Cars, Freight Transport MTMA <= 3,5t, Freight Transport 3,5t <MTMA <= 7,5t etc. You can find the vehicle category at position J and the maximum authorized technical mass (MTMA) at position F1 in the registration certificate) "
        ),
      ]),
      _c("li", [
        _vm._v(
          " - Select the validity period of the vignette (rovinieta), the date from which will enter into force, the registration number, the chassis series (although it is not mandatory for 1-day and 7-day, we recommend passing the chassis series for the correctness of the data), the country of registration and, optionally, the reason for the lower category (to be completed only if the selected category is lower than in the RAR records). "
        ),
      ]),
      _c("li", [
        _vm._v(
          ' - Add the vignette (rovinieta) to the basket. You can add other vignettes to the cart, by pressing the "buy more" button '
        ),
      ]),
      _c("li", [
        _vm._v(
          " - In the next step you can enter your account and choose the billing data already saved or you can place the order without an account by filling in the required data in the form. "
        ),
      ]),
      _c("li", [
        _vm._v(
          " - In the next step you can choose the payment method - online by bank card, through the secure card processor, or by bank payment order. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("ATTENTION")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "special-title" }, [
      _c("strong", [_vm._v("Fetesti Toll")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "Select the vehicle category (e.g. Category 1 - Cars, Freight Transport MTMA <= 3,5t, Category 2 - Freight Transport 3,5t <MTMA <= 7,5t etc. You can find the vehicle category at position J and the maximum authorized technical mass (MTMA) at position F1 in the registration certificate)"
        ),
      ]),
      _c("li", [
        _vm._v(
          "Select the number of passings (1, 2 or 20), the plate number, the chassis series, the country of registration and, optionally, the reason for the lower category (to be completed only if the selected category is lower than in the RAR records)."
        ),
      ]),
      _c("li", [
        _vm._v(
          'Add the bridge toll to the basket. You can add other tolls to the cart, by pressing the "buy more" button'
        ),
      ]),
      _c("li", [
        _vm._v(
          "In the next step you can enter your account and choose the billing data already saved or you can place the order without an account by filling in the required data in the form."
        ),
      ]),
      _c("li", [
        _vm._v(
          "In the next step you can choose the payment method - online by bank card, through the secure card processor, or by bank payment order."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }